import React from 'react'

const Loading = () => {
	return (
		<div className="reward-loading">
			<span className="loading-all">
			</span>
		</div>
	);
}

export default Loading;